import type { ModelAddButtonOptions } from "@/modules/model-add-button";

import OrganizationCreate from "@/features/Organizations/Create";
import ModelAddButton from "@/modules/model-add-button";

const OrganizationAddButton = (options: ModelAddButtonOptions) => {
  return (
    <ModelAddButton
      model="organization"
      component={<OrganizationCreate />}
      {...options}
    />
  );
};

export default OrganizationAddButton;
